import { Logo } from "@/components/logo";

export function SiteFooter() {
	return (
		<footer data-slot="site-footer">
			<div data-slot="site-footer-inner">
				<div data-slot="site-footer-row">
					<span data-slot="brand" data-size="sm">
						<Logo />
						<span data-slot="brand-name">Obra Todo Dia</span>
					</span>
					<span>Obra, pessoas e números desta página são exemplos.</span>
				</div>
				<p data-slot="credits">
					Fotos: MTA Construction &amp; Development (Metropolitan Transportation
					Authority of the State of New York), CC BY 2.0, via Wikimedia Commons.
				</p>
			</div>
		</footer>
	);
}
